import React, { useState } from 'react';
import { Box, Typography, Container, TextField, Button } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { keyframes } from '@mui/system';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

// Keyframes for animation
const shakeAnimation = keyframes`
  10%, 90% { transform: translateX(-1px); }
  20%, 80% { transform: translateX(2px); }
  30%, 50%, 70% { transform: translateX(-4px); }
  40%, 60% { transform: translateX(4px); }
`;

const Contact = () => {
    const { t } = useTranslation();
    const [formValues, setFormValues] = useState({
        name: '',
        email: '',
        message: '',
    });
    const theme = useTheme();

    const handleChange = (e) => {
        setFormValues({
            ...formValues,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        alert(t('contact.messageSentAlert'));
        setFormValues({ name: '', email: '', message: '' });
    };

    return (
        <Box sx={{ backgroundColor: theme.palette.background.primary, color: theme.palette.text.default, py: 8 }}>
            <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
                <Typography variant="h2" fontWeight="bold" gutterBottom>
                    {t('contact.title')}
                </Typography>
                <Typography variant="h6" gutterBottom>
                    {t('contact.subtitle')}
                </Typography>
                
                <Box
                    component="form"
                    onSubmit={handleSubmit}
                    sx={{ mt: 4, display: 'flex', flexDirection: 'column', gap: 3 }}
                >
                    <TextField
                        variant="filled"
                        label={t('contact.nameLabel')}
                        name="name"
                        value={formValues.name}
                        onChange={handleChange}
                        required
                        fullWidth
                        InputProps={{ style: { color:'dodgerblue'  } }}
                        sx={{
                            '& .MuiFilledInput-root': {backgroundColor: theme.palette.background.primary  },
                            '& .MuiInputLabel-root': { color: theme.palette.text.default }
                        }}
                    />
                    <TextField
                        variant="filled"
                        label={t('contact.emailLabel')}
                        name="email"
                        type="email"
                        value={formValues.email}
                        onChange={handleChange}
                        required
                        fullWidth
                        InputProps={{ style: { color: 'dodgerblue'  } }}
                        sx={{
                            '& .MuiFilledInput-root': {backgroundColor: theme.palette.background.primary },
                            '& .MuiInputLabel-root': { color: theme.palette.text.default }
                        }}
                    />
                    <TextField
                        variant="filled"
                        label={t('contact.messageLabel')}
                        name="message"
                        multiline
                        rows={4}
                        value={formValues.message}
                        onChange={handleChange}
                        required
                        fullWidth
                        InputProps={{ style: { color: 'dodgerblue' } }}
                        sx={{
                            '& .MuiFilledInput-root': {backgroundColor:theme.palette.background.primary },
                            '& .MuiInputLabel-root': { color: theme.palette.text.default }
                        }}
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        endIcon={<SendIcon />}
                        sx={{
                            animation: `${shakeAnimation} 2s ease-in-out infinite`,
                            fontWeight: 'bold',
                            px: 4,
                        }}
                    >
                        {t('contact.sendMessageButton')}
                    </Button>
                </Box>
            </Container>
        </Box>
    );
};

export default Contact;
